import React, { Component } from 'react';
import { Header, HeaderGlobalBar } from "carbon-components-react";
import NetworkStatusIndicator from './NetworkStatusIndicator.js';
import { api } from '../../services/api.js';// RITM0954296-HOCCardTranslate

export class Head extends Component {

  constructor(props) {
    super(props);
    this.showProfile = this.showProfile.bind(this);
    const language = window.localStorage.getItem("selectedLanguage");// RITM0954296-HOCCardTranslate
    this.state = {
      isOpenProfile: false,
      hocCardTranslate: [], // RITM0954296
      //selectedLanguage: '',
      selectedLanguage:  language, //RITM0954296 
    };
  }

  showProfile() {
    this.setState((oldState) => ({
      isOpenProfile: !oldState.isOpenProfile,
    }));
  }
  // RITM0954296-HOCCardTranslate
  handleChangeLanguage = (event) => {

    window.localStorage.removeItem("hocCardTranslate");
    window.localStorage.removeItem("selectedLanguage");
    this.setState({ selectedLanguage: event.target.value });
    window.localStorage.setItem("selectedLanguage", event.target.value);
    api.translate
      .get('options', { params: { language: event.target.value } })
      .then((response) => {
        this.setState({ hocCardTranslate: response.data });
        window.localStorage.setItem("hocCardTranslate", JSON.stringify(this.state.hocCardTranslate));       
        window.location.reload();
      });
   
  };
  // RITM0954296  end
  render() {
    return (
      <Header className="header" aria-label="Header">
        <HeaderGlobalBar className="header-global">
          <div className="home" to="/"></div>
        </HeaderGlobalBar>

        <HeaderGlobalBar className="header-global">
          <div className="title">
            <span>HOC 4 All</span>            
          </div>
        </HeaderGlobalBar>
        <HeaderGlobalBar className="header-global">
        <div className="title">
          <div>
            <span> <label htmlFor="dropdown">Translate :</label></span>
            <select id="idLanguage" value={this.state.selectedLanguage} onChange={this.handleChangeLanguage}  >
              <option value="English">English</option>
              <option value="Italian">Italian</option>
              <option value="Filipino">Filipino</option>
              <option value="Indonesian">Indonesian</option>
              {/* RITM1386795 */}
              <option value="Portuguese">Portuguese</option>
            </select>
          </div>
          </div>
        </HeaderGlobalBar>
        <HeaderGlobalBar className="header-tail">
         
          <NetworkStatusIndicator {...this.props.synchStatus} />        
        </HeaderGlobalBar>
      </Header>
    );
  }
}
